<template>
  <router-view></router-view>
</template>

<script>
import { SET_MAP_OPTIONS } from './constants/store-mutation-types'
export default {
  name: 'app',
  mounted() {
    this.getSetting()
    this.initializeNotification()
    this.initializeIssueCollector()
  },
  methods: {
    initializeIssueCollector() {
      const stages = ['development', 'product']
      if (stages.includes(process.env.NODE_ENV)) {
        const jiraScript = document.createElement('script')
        jiraScript.setAttribute(
          'src',
          'http://192.168.7.11:8098/s/85d2240e514425a49d7de0010cbbf56c-T/-53297u/817000/1dlckms/62e19cd792b90b189926e493402649cc/_/download/contextbatch/js/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/batch.js?locale=en-US&collectorId=45d656f0'
        )
        document.head.appendChild(jiraScript)

        this.changeCollectorButtonStyle()
      }
    },
    changeCollectorButtonStyle() {
      setTimeout(() => {
        const collectorButton = document.getElementById('atlwdg-trigger')
        if (collectorButton) {
          collectorButton.classList.add(
            'barbanet-btn',
            'red',
            'small',
            'w-auto'
          )
          collectorButton.style.setProperty('color', 'white', 'important')
        } else this.changeCollectorButtonStyle()
      }, 100)
    },
    initializeNotification() {
      if (this.$config.firebase) {
        Notification.requestPermission().then((permission) => {
          if (permission === 'granted') {
            this.$fire.messaging
              .getToken({ vapidKey: this.$config.firebase.vapidKey })
              .then((token) => {
                this.$api.publicMessageNotification
                  .subscribe({ token })
                  .catch((error) => console.error('error in subscribe:', error))
              })
          }
        })
      }
    },
    getSetting() {
      this.$api.setting.get().then((response) => {
        this.$store.commit(SET_MAP_OPTIONS, response.mapOptions)
      })
    }
  }
}
</script>

<style lang="scss">
// Import vazir Font
@import '~vazir-font/dist/font-face.css';
// Import Main styles for this application
@import 'assets/scss/style';
</style>

<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  appearance: textfield !important;
  -moz-appearance: textfield !important;
}

::-moz-selection {
  /* Code for Firefox */
  color: #fff;
  background: #00a88e;
}

::selection {
  color: #fff;
  background: #00a88e;
}

.tree-children,
.tree-root {
  list-style: none;
  padding: unset !important;
  margin-right: 20px !important;
}
</style>
